module.exports = __webpack_public_path__ + "img/icon-moon.6c4265d6.svg";